import React from "react";
import styled from "styled-components";

const Badge = ({ variant = "info", color, size = "sm", children, className }) => (
  <Pill variant={variant} $color={color} $size={size} className={className}>
    {children}
  </Pill>
);

export default Badge;

const toAlpha = (rgba, a) => rgba.replace(/,\s*[\d.]+\)$/, `, ${a})`);

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: 20px;
  font-weight: 600;
  letter-spacing: 0.3px;
  white-space: nowrap;
  line-height: 1.4;

  font-size: ${({ $size }) =>
    $size === "xs" ? "10px" : $size === "md" ? "13px" : "11px"};
  padding: ${({ $size }) =>
    $size === "xs" ? "1px 6px" : $size === "md" ? "4px 10px" : "2px 8px"};

  color: ${({ variant, $color, theme }) => {
    if ($color) return $color;
    if (variant === "required") return theme.menu.deleteColor;
    if (variant === "new") return "#22c55e";
    if (variant === "beta") return "#f59e0b";
    return theme.menu.selectedTextColor;
  }};

  background: ${({ variant, $color, theme }) => {
    if ($color) return toAlpha($color, 0.15);
    if (variant === "required") return toAlpha(theme.menu.deleteColor, 0.13);
    if (variant === "new") return "rgba(34,197,94,0.13)";
    if (variant === "beta") return "rgba(245,158,11,0.13)";
    return toAlpha(theme.menu.selectedTextColor, 0.13);
  }};
`;
